<template>
  <div class="page-title">
    <template v-if="balancesBrokerRequestStatus === RequestStatus.Default">
      <HeadingDisplay
        :head="data.section.title"
        title=""
        :subtitle="subtitle"
        size="medium"
      >
        <template #title-component>
          <Money>{{ title }}</Money>
        </template>
      </HeadingDisplay>
      <div
        v-if="marginStock && marginStock.amount.value > 0"
        class="balances__heading"
      >
        <BaseText size="p6">Saldo de garantia</BaseText>
        <div class="balances__value">
          <Heading :level="6">
            <Money width="100px">{{ marginStock.amount.formatted }}</Money>
          </Heading>
          <ButtonIconContextual
            size="extra-small"
            label="Informações sobre saldo de garantia"
            icon="EF0080"
            @click="() => (isDetailsModalOpen = true)"
          />
        </div>
      </div>
    </template>
    <template v-else-if="balancesBrokerRequestStatus === RequestStatus.Loading">
      <HeadingDisplayLoader class="page-title__loader" size="medium" />
    </template>
    <template v-else-if="balancesBrokerRequestStatus === RequestStatus.Error">
      <div class="page-title__error">
        <HeadingDisplay
          :head="data.error.title"
          :title="data.error.subtitle"
          :subtitle="data.error.description"
          size="small"
        />
        <ButtonSecondary
          icon="EA0140"
          icon-position="right"
          class="page-title__error__button"
          :label="data.error.buttonLabel"
          @click="handleRetryClick"
        />
      </div>
    </template>
    <BalanceDetailsModal
      v-if="marginStock"
      :is-open="isDetailsModalOpen"
      :details="marginStock.details"
      @close="isDetailsModalOpen = false"
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import {
  BaseText,
  Heading,
  HeadingDisplay,
  SkeletonLoader,
  ButtonSecondary,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { Money } from '@/modules/common/components/MoneyV2';
import { BalanceDetailsModal } from '@/modules/transaction/views/Transactions/components/Balances/components/BalanceDetailsModal';
import { IHeroBalances } from '@/modules/trade/services/account';
import { RequestStatus } from '@/modules/trade/store/trade';
import { useDashStore } from '@/modules/common/store/DashModule';
import { data } from './data';

const tradePositionsModule = namespace('tradeModule');

@Component({
  components: {
    BalanceDetailsModal,
    BaseText,
    Heading,
    HeadingDisplay,
    SkeletonLoader,
    ButtonSecondary,
    HeadingDisplayLoader,
    Money,
    ButtonIconContextual
  }
})
export default class PageTitle extends Vue {
  readonly data = data;
  private readonly dashModule = useDashStore();
  private isDetailsModalOpen = false;

  @tradePositionsModule.State('balancesBrokerRequestStatus')
  readonly balancesBrokerRequestStatus!: RequestStatus;

  @tradePositionsModule.State('balances')
  readonly balances?: IHeroBalances | null;

  @tradePositionsModule.Action('fetchBalances')
  readonly fetchBalances!: Function;

  @tradePositionsModule.State('balanceRequestStatus')
  readonly balanceRequestStatus!: RequestStatus;

  readonly RequestStatus = RequestStatus;

  handleRetryClick() {
    this.fetchBalances();
  }

  get showMoney() {
    return this.dashModule;
  }

  get title() {
    return this.balances?.totalBalance?.formatted || '-';
  }

  get subtitle() {
    return this.balances?.totalBalanceUpdatedAt?.formatted || '-';
  }

  get marginStock() {
    return this.balances?.marginStock || null;
  }
}
</script>

<style lang="less" scoped>
.page-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__loader {
    width: 50%;
  }

  &__error {
    &__button {
      margin-left: calc(-1 * @size-spacing-x350);
    }
  }
}

.balances {
  &__heading {
    .p6 {
      color: @element-primary !important;
    }
  }

  &__value {
    display: flex;
    align-items: center;
  }
}
</style>
